import * as React from 'react';
import { Image } from '@cian/ui-kit';

import * as styles from './styles.css';
import { IGalleryItem } from '../../../../types/redux/gallery';
import { Category } from '../Category';

interface IContentProps {
  gallery: IGalleryItem[];
  published: boolean;
}

export function Content({ gallery }: IContentProps): React.JSX.Element {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        {gallery.map(category => (
          <div className={styles['category']} key={category.id} id={category.id}>
            <Category title={category.title}>
              {category.media.map((item, index) => (
                <div className={styles['image']} key={index}>
                  <Image src={item.url} height="auto" width="100%" borderRadius="0" objectFit="contain" />
                </div>
              ))}
            </Category>
          </div>
        ))}
      </div>
    </div>
  );
}
